module.exports = __webpack_public_path__ + "img/icon_08.d4bbf6d3.svg";